import { render, staticRenderFns } from "./DetaliiClient.vue?vue&type=template&id=530aec8f&scoped=true"
import script from "./DetaliiClient.vue?vue&type=script&lang=js"
export * from "./DetaliiClient.vue?vue&type=script&lang=js"
import style0 from "./DetaliiClient.vue?vue&type=style&index=0&id=530aec8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530aec8f",
  null
  
)

export default component.exports